module.exports = __webpack_public_path__ + "img/a-skelding-a-day-keeps-the-doctor-away.cda6fca7.jpg";